import React from "react";
import classNames from "classnames/bind";
import styles from "./News.module.scss";
import Pagination from "../commons/Pagination/Pagination";
import dayjs from "dayjs";

const cx = classNames.bind(styles);

export default function News({
  currentPage,
  lastPage,
  perPage,
  total,
  data,
  options,
  handlePage,
  handleOptions,
  handleDelete,
  handleDetailMove,
}) {
  return (
    <>
      <div className={cx("option_container")}>
        <div className={cx("option_inner")}>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>구분</p>
            </div>
            <div className={cx("option_button_box")}>
              <button
                className={cx("option_button", {
                  active: options.locale === "",
                })}
                onClick={() => handleOptions("locale", "")}
              >
                전체
              </button>
              <button
                className={cx("option_button", {
                  active: options.locale === "ko",
                })}
                onClick={() => handleOptions("locale", "ko")}
              >
                한국어
              </button>
              <button
                className={cx("option_button", {
                  active: options.locale === "en",
                })}
                onClick={() => handleOptions("locale", "en")}
              >
                영문
              </button>
            </div>
          </div>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>정렬</p>
            </div>
            <div className={cx("option_button_box")}>
              <button
                className={cx("option_button", {
                  active: options.sort === "desc",
                })}
                onClick={() => handleOptions("sort", "desc")}
              >
                최신순
              </button>
              <button
                className={cx("option_button", {
                  active: options.sort === "asc",
                })}
                onClick={() => handleOptions("sort", "asc")}
              >
                오래된순
              </button>
            </div>
          </div>
        </div>
        <div className={cx("option_inner")}>
          <div className={cx("option_box", "hidden_option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>소식 유형</p>
            </div>
          </div>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>검색어</p>
            </div>
            <div className={cx("option_button_box")}>
              <input
                type="text"
                className={cx("input")}
                value={options?.search}
                name="search"
                onChange={(e) => handleOptions("search", e.target.value)}
                placeholder="제목 혹은 내용을 입력해 주세요."
              />
            </div>
          </div>
        </div>
      </div>
      <div className={cx("table_container")}>
        <table className={cx("table")}>
          <thead>
            <tr>
              <th className={cx("th")}>번호</th>
              <th className={cx("th")}>구분</th>
              <th className={cx("th")}>제목</th>
              <th className={cx("th")}>내용</th>
              <th className={cx("th")}>작성일</th>
              <th className={cx("th")}>관리</th>
            </tr>
          </thead>
          <tbody>
            {data[currentPage]?.map((el) => (
              <tr key={el.id}>
                <td className={cx("td")}>{el.id}</td>
                <td className={cx("td")}>
                  {el?.locale === "ko" ? "한국어" : "영문"}
                </td>
                <td className={cx("td")}>{el?.title}</td>
                <td className={cx("td")}>{el?.content}</td>
                <td className={cx("td")}>
                  {dayjs(el?.created_at).format("YYYY.MM.DD")}
                </td>
                <td className={cx("td")}>
                  <button
                    onClick={() => handleDetailMove(el?.id)}
                    className={cx("table_button")}
                  >
                    상세보기
                  </button>
                  <button
                    onClick={() => handleDelete(el?.id)}
                    className={cx("table_button")}
                  >
                    삭제
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {total && total !== 0 ? (
        <Pagination
          currentPage={currentPage}
          lastPage={lastPage}
          perPage={perPage}
          handlePage={handlePage}
        />
      ) : (
        <div className={cx("empty_box")}>
          <p className={cx("empty_text")}>등록 된 소식이 없습니다.</p>
        </div>
      )}
      <div className={cx("button_box")}>
        <button onClick={() => handleDetailMove(null)} className={cx("button")}>
          소식 추가
        </button>
      </div>
    </>
  );
}
